import { getRequestOptions, getAxiosConfig } from '../helpers/Fetchwrapper';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const DashboardService = {
    /**
     * Get dashboard statistics
     */
    getDashboardStats: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/stats`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching dashboard stats:', error);
            throw error;
        }
    },

    /**
     * Get recent orders for dashboard
     */
    getRecentOrders: async (limit = 5) => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/recent-orders?limit=${limit}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching recent orders:', error);
            throw error;
        }
    },

    /**
     * Get top selling products
     */
    getTopProducts: async (limit = 5) => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/top-products?limit=${limit}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching top products:', error);
            throw error;
        }
    },

    /**
     * Get recent customers
     */
    getRecentCustomers: async (limit = 5) => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/recent-customers?limit=${limit}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching recent customers:', error);
            throw error;
        }
    },

    /**
     * Get sales chart data
     */
    getSalesChartData: async (period = '30days') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/sales-chart?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching sales chart data:', error);
            throw error;
        }
    },

    /**
     * Get revenue data
     */
    getRevenueData: async (period = '12months') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/revenue?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching revenue data:', error);
            throw error;
        }
    },

    /**
     * Get order status distribution
     */
    getOrderStatusDistribution: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/order-status-distribution`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching order status distribution:', error);
            throw error;
        }
    },

    /**
     * Get low stock products
     */
    getLowStockProducts: async (limit = 5) => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/low-stock?limit=${limit}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching low stock products:', error);
            throw error;
        }
    },

    /**
     * Get customer growth data
     */
    getCustomerGrowth: async (period = '12months') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/customer-growth?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching customer growth data:', error);
            throw error;
        }
    },

    /**
     * Get category performance data
     */
    getCategoryPerformance: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/category-performance`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching category performance:', error);
            throw error;
        }
    },

    /**
     * Get daily metrics (orders, revenue, customers)
     */
    getDailyMetrics: async (period = '30days') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/daily-metrics?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching daily metrics:', error);
            throw error;
        }
    },

    /**
     * Get real-time dashboard updates
     */
    getRealTimeUpdates: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/real-time`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching real-time updates:', error);
            throw error;
        }
    },

    /**
     * Get performance metrics
     */
    getPerformanceMetrics: async (period = '30days') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/performance?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching performance metrics:', error);
            throw error;
        }
    },

    /**
     * Get geographic data for sales
     */
    getGeographicData: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/geographic-data`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching geographic data:', error);
            throw error;
        }
    },

    /**
     * Get customer analytics
     */
    getCustomerAnalytics: async (period = '30days') => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/customer-analytics?period=${period}`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching customer analytics:', error);
            throw error;
        }
    },

    /**
     * Get inventory insights
     */
    getInventoryInsights: async () => {
        try {
            const response = await fetch(
                `${API_URL}dashboard/inventory-insights`,
                getRequestOptions()
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching inventory insights:', error);
            throw error;
        }
    }
};

export default DashboardService; 